(function () {
  "use strict";

  var root = document.querySelector("[data-wp-agent-drawer]");
  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  var drawer = root.querySelector(".wp-agent-drawer");
  var backdrop = root.querySelector(".wp-agent-backdrop");
  var conversationView = root.querySelector("[data-agent-conversation-view]");
  var historyView = root.querySelector("[data-agent-history-view]");
  var historyList = root.querySelector("[data-agent-history-list]");
  var historyNote = root.querySelector("[data-agent-history-note]");
  var transcript = root.querySelector("[data-agent-transcript]");
  var welcome = root.querySelector("[data-agent-welcome]");
  var form = root.querySelector("[data-agent-form]");
  var input = root.querySelector("[data-agent-input]");
  var send = root.querySelector("[data-agent-send]");
  var statusNode = root.querySelector("[data-agent-status]");
  var statusTitle = root.querySelector("[data-agent-status-title]");
  var statusCopy = root.querySelector("[data-agent-status-copy]");
  var retryButton = root.querySelector("[data-agent-retry]");
  var progressNode = root.querySelector("[data-agent-progress]");
  var briefNode = root.querySelector("[data-agent-brief]");
  var briefSummary = root.querySelector("[data-agent-brief-summary]");
  var sourcingConfirm = root.querySelector("[data-agent-sourcing-confirm]");
  var sourcingFacts = root.querySelector("[data-agent-sourcing-facts]");
  var contextNode = root.querySelector("[data-agent-context]");
  var historyButton = root.querySelector("[data-agent-history]");
  var signedIn = root.dataset.signedIn === "true";
  var accountApi = String(root.dataset.accountApi || "/apps/wp-account").replace(/\/$/, "");
  var publicApi = String(root.dataset.publicApi || "https://wp-api.sendfromchina.ai").replace(/\/$/, "");
  var workspaceUrl = root.dataset.workspaceUrl || "/apps/wp-account/workspace";
  var loginUrl = root.dataset.loginUrl || "/customer_authentication/login";
  var previousFocus = null;
  var historyLoaded = false;
  var state = {
    busy: false,
    conversation: null,
    conversations: [],
    messages: [],
    publicMessages: [],
    criteria: {},
    sessionId: clientId("chat"),
    cursor: "",
    productContextUsed: false,
    retry: null,
  };

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-open-agent-drawer]");
    if (!trigger) return;
    event.preventDefault();
    openDrawer(trigger.dataset.agentBrief || "", trigger.dataset.agentAutoSend === "true");
  });
  window.addEventListener("wp:open-agent", function (event) {
    var detail = event.detail || {};
    openDrawer(detail.brief || "", detail.autoSend === true);
  });
  root.querySelectorAll("[data-agent-close]").forEach(function (button) { button.addEventListener("click", closeDrawer); });
  historyButton.addEventListener("click", function () {
    if (!historyView.hidden) {
      showConversation();
      input.focus();
      return;
    }
    showHistory();
  });
  root.querySelector("[data-agent-new]").addEventListener("click", startNewConversation);
  root.querySelector("[data-agent-edit-brief]").addEventListener("click", function () { input.focus(); });
  root.querySelector("[data-agent-keep-chatting]").addEventListener("click", function () {
    sourcingConfirm.hidden = true;
    input.focus();
  });
  root.querySelector("[data-agent-start-sourcing]").addEventListener("click", startSourcing);
  retryButton.addEventListener("click", function () {
    var retry = state.retry;
    clearStatus();
    if (retry) sendMessage(retry);
  });
  root.querySelectorAll("[data-agent-starter]").forEach(function (button) {
    button.addEventListener("click", function () { input.value = button.dataset.agentStarter || ""; sendMessage(); });
  });
  form.addEventListener("submit", function (event) { event.preventDefault(); sendMessage(); });
  input.addEventListener("keydown", function (event) {
    if (event.key === "Enter" && !event.shiftKey) { event.preventDefault(); sendMessage(); }
  });
  input.addEventListener("input", resizeInput);
  window.addEventListener("resize", syncLayoutMode);
  document.addEventListener("keydown", function (event) {
    if (drawer.hidden) return;
    if (event.key === "Escape") closeDrawer();
    if (event.key === "Tab") trapFocus(event);
  });

  renderProductContext();

  function openDrawer(brief, autoSend) {
    previousFocus = document.activeElement;
    drawer.hidden = false;
    backdrop.hidden = false;
    document.documentElement.classList.add("wp-agent-is-open");
    syncLayoutMode();
    document.querySelectorAll("[data-open-agent-drawer]").forEach(function (trigger) { trigger.setAttribute("aria-expanded", "true"); });
    showConversation();
    if (brief) {
      input.value = String(brief).trim().slice(0, 1000);
      resizeInput();
      if (autoSend) window.setTimeout(sendMessage, 0);
    }
    window.setTimeout(function () { input.focus(); }, 0);
  }

  function closeDrawer() {
    drawer.hidden = true;
    backdrop.hidden = true;
    document.documentElement.classList.remove("wp-agent-is-open");
    delete root.dataset.layout;
    document.querySelectorAll("[data-open-agent-drawer]").forEach(function (trigger) { trigger.setAttribute("aria-expanded", "false"); });
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  function showConversation() {
    historyView.hidden = true;
    conversationView.hidden = false;
    historyButton.setAttribute("aria-expanded", "false");
  }

  async function showHistory() {
    conversationView.hidden = true;
    historyView.hidden = false;
    historyButton.setAttribute("aria-expanded", "true");
    if (!signedIn) {
      historyList.replaceChildren();
      historyNote.textContent = "This conversation is private to this browser session. Sign in from the full Agent view to save briefs, requests, and prepared products.";
      return;
    }
    if (!historyLoaded) await loadHistory();
  }

  async function loadHistory() {
    historyList.replaceChildren(textNode("Loading saved conversations...", "wp-agent-history-note"));
    try {
      var page = await api(accountApi + "/conversations?limit=30");
      state.conversations = page.conversations || [];
      historyLoaded = true;
      renderHistory();
    } catch (error) {
      historyList.replaceChildren(textNode(error.message || "Saved conversations are temporarily unavailable.", "wp-agent-history-note"));
    }
  }

  function renderHistory() {
    historyList.replaceChildren();
    if (!state.conversations.length) {
      historyList.appendChild(textNode("No saved conversations yet.", "wp-agent-history-note"));
      return;
    }
    state.conversations.forEach(function (conversation) {
      var button = element("button", { className: "wp-agent-history-item", type: "button" });
      button.appendChild(textNode(conversation.title || "Product request", "strong"));
      button.appendChild(textNode(conversation.updated_at ? formatDate(conversation.updated_at) : "Saved conversation", "span"));
      button.addEventListener("click", function () { openConversation(conversation.id); });
      historyList.appendChild(button);
    });
    historyNote.textContent = "Conversations, sourcing progress, and prepared products remain attached to your account.";
  }

  async function openConversation(id) {
    setBusy(true, "Opening conversation...");
    try {
      var page = await api(accountApi + "/conversations/" + encodeURIComponent(id));
      state.conversation = page.conversation || null;
      state.messages = page.messages || [];
      state.criteria = state.conversation && state.conversation.criteria || {};
      renderConversation();
      showConversation();
    } catch (error) {
      showStatus(error.message, "error");
    } finally {
      setBusy(false);
    }
  }

  function startNewConversation() {
    state.conversation = null;
    state.messages = [];
    state.publicMessages = [];
    state.criteria = {};
    state.cursor = "";
    state.sessionId = clientId("chat");
    state.productContextUsed = false;
    sourcingConfirm.hidden = true;
    renderConversation();
    showConversation();
    input.focus();
  }

  async function sendMessage(options) {
    var config = options || {};
    var value = String(config.message || input.value || "").trim();
    if (!value || state.busy) return;
    input.value = "";
    resizeInput();
    sourcingConfirm.hidden = true;
    clearStatus();
    state.retry = {
      message: value,
      messageId: config.messageId || clientId("msg"),
      operation: config.operation,
      criteria: config.criteria,
      cursor: config.cursor,
    };
    var outgoing = contextualMessage(value);
    if (signedIn) {
      state.messages.push({ role: "user", content: value, message_key: clientId("pending"), payload: {} });
    } else {
      state.publicMessages.push({ role: "user", content: outgoing });
    }
    renderConversation();
    setBusy(true, "Searching the catalog and checking the brief...");
    try {
      var backendPayload = signedIn
        ? await sendAccountMessage(outgoing, state.retry)
        : await sendPublicMessage(config);
      var degradedFallback = false;
      if (shouldApplyCatalogFallback(backendPayload)) {
        degradedFallback = await applyShopifyCatalogFallback(value).catch(function () { return false; });
      }
      state.productContextUsed = true;
      state.retry = null;
      renderConversation();
      if (degradedFallback) showCatalogFallbackStatus(degradedFallback.resultCount);
    } catch (error) {
      var catalogFallback = await applyShopifyCatalogFallback(value).catch(function () { return false; });
      if (catalogFallback) {
        state.productContextUsed = true;
        state.retry = null;
        renderConversation();
        showCatalogFallbackStatus(catalogFallback.resultCount);
        return;
      }
      var messageSaved = signedIn && error && error.messageSaved === true;
      if (!messageSaved) {
        if (signedIn) state.messages.pop();
        else state.publicMessages.pop();
        input.value = value;
        resizeInput();
      } else {
        await refreshAccountConversation(error.conversationId).catch(function () {});
      }
      renderConversation();
      showStatus(error, "error");
    } finally {
      setBusy(false);
      window.requestAnimationFrame(scrollToEnd);
    }
  }

  async function sendAccountMessage(value, config) {
    var response = await api(accountApi + "/chat", {
      method: "POST",
      body: JSON.stringify({
        conversation_id: state.conversation && state.conversation.id || "",
        message_id: config.messageId || clientId("msg"),
        message: value,
        operation: config.operation || "chat",
        criteria: config.criteria || state.criteria || {},
        cursor: config.cursor || null,
        limit: 20,
      }),
    });
    applyAccountChatResponse(response);
    // The POST already committed the message and returns enough data to render
    // immediately. A transient read-after-write refresh must not turn a
    // successful reply into a customer-facing outage.
    await refreshAccountConversation(response.conversation_id).catch(function () {});
    historyLoaded = false;
    return response;
  }

  function applyAccountChatResponse(response) {
    var conversation = response && response.conversation;
    if (conversation) state.conversation = conversation;
    else if (response && response.conversation_id) {
      state.conversation = Object.assign({}, state.conversation || {}, { id: response.conversation_id });
    }
    state.criteria = response && response.criteria
      || state.conversation && state.conversation.criteria
      || state.criteria
      || {};
    var reply = response && response.message;
    if (!reply && response && (response.reply || response.answer)) {
      reply = {
        role: "assistant",
        content: response.reply || response.answer,
        payload: response,
        message_key: clientId("reply"),
      };
    }
    if (!reply) return;
    var key = String(reply.message_key || reply.id || "");
    var exists = key && state.messages.some(function (message) {
      return String(message.message_key || message.id || "") === key;
    });
    if (!exists) state.messages.push(reply);
  }

  async function refreshAccountConversation(conversationId) {
    var id = String(conversationId || state.conversation && state.conversation.id || "").trim();
    if (!id) return false;
    var page = await api(accountApi + "/conversations/" + encodeURIComponent(id));
    state.conversation = page.conversation || state.conversation || null;
    if (Array.isArray(page.messages)) state.messages = page.messages;
    state.criteria = state.conversation && state.conversation.criteria || state.criteria || {};
    return true;
  }

  async function sendPublicMessage(config) {
    var payload = await api(publicApi + "/api/chat", {
      method: "POST",
      body: JSON.stringify({
        session_id: state.sessionId,
        messages: state.publicMessages.slice(-12),
        criteria: config.criteria || state.criteria || {},
        operation: config.operation || "chat",
        cursor: config.cursor || "",
        limit: 20,
      }),
    });
    state.sessionId = payload.session_id || state.sessionId;
    state.criteria = payload.criteria || state.criteria || {};
    state.cursor = payload.next_cursor || "";
    state.publicMessages.push({
      role: "assistant",
      content: payload.reply || payload.answer || "I could not find a confident catalog match.",
      payload: payload,
    });
    return payload;
  }

  function shouldApplyCatalogFallback(payload) {
    var envelope = catalogEnvelope(payload);
    if (!envelope || preparedResults(envelope.results).length) return false;
    var scope = envelope.search_scope || {};
    var terminalNoMatch = envelope.status === "no_match"
      && envelope.degraded !== true
      && scope.degraded !== true
      && envelope.bounded_plan_complete === true
      && envelope.exhaustive === true
      && envelope.search_scope_exhausted === true
      && envelope.scan_limit_reached !== true;
    if (terminalNoMatch) return false;
    var status = String(envelope.status || envelope.catalog_status || "").toLowerCase();
    var coverage = String(envelope.coverage || envelope.catalog_coverage || "").toLowerCase();
    return envelope.degraded === true
      || scope.degraded === true
      || ["degraded", "unavailable", "service_unavailable"].includes(status)
      || /degraded|incomplete|unavailable/.test(coverage);
  }

  function catalogEnvelope(payload) {
    var candidates = [
      payload,
      payload && payload.catalog,
      payload && payload.search,
      payload && payload.message && payload.message.payload,
      payload && payload.response,
    ];
    return candidates.find(function (candidate) {
      return candidate && typeof candidate === "object"
        && (Array.isArray(candidate.results) || candidate.status || candidate.degraded === true || candidate.search_scope);
    }) || null;
  }

  async function applyShopifyCatalogFallback(value) {
    var query = fallbackCatalogQuery(value);
    if (!query) return false;
    var constraints = fallbackConstraints(value);
    var url = new URL("/search/suggest.json", window.location.origin);
    url.searchParams.set("q", query);
    url.searchParams.set("country", "US");
    url.searchParams.set("resources[type]", "product");
    url.searchParams.set("resources[limit]", "10");
    url.searchParams.set("resources[options][unavailable_products]", "hide");
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 8000);
    try {
      var response = await fetch(url.href, {
        method: "GET",
        credentials: "same-origin",
        headers: { "Accept": "application/json" },
        signal: controller.signal,
      });
      if (!response.ok) return false;
      var payload = await response.json().catch(function () { return {}; });
      var raw = payload && payload.resources && payload.resources.results && payload.resources.results.products;
      var candidates = Array.isArray(raw) ? raw.map(fallbackProduct).filter(Boolean) : [];
      var results = candidates.filter(function (product) { return fallbackConstraintMatch(product, constraints); });
      var relaxations = [];
      if (constraints.destinationRequested) relaxations.push("Delivery and destination fit were not verified; confirm them at checkout.");
      if (constraints.material && candidates.length && !results.length) relaxations.push("The requested material could not be verified in public catalog fields.");
      if (constraints.priceMax != null && candidates.length && !results.length) relaxations.push("No returned public suggestion could be verified within the stated budget.");
      var content = results.length
        ? "The full conversational service is temporarily unavailable. I found " + String(results.length) + " available product" + (results.length === 1 ? "" : "s") + " using Shopify's public catalog search. These are read-only suggestions; confirm options, price, and delivery on the product page."
        : "The full conversational service is temporarily unavailable, so I could not verify a product against every part of this brief. Try a broader product category or browse the catalog; this is not a confirmed no-match.";
      var message = {
        role: "assistant",
        content: content,
        message_key: clientId("fallback"),
        payload: {
          status: "degraded",
          degraded: true,
          source: "shopify_predictive_search",
          read_only: true,
          results: results,
          relaxations: relaxations,
        },
      };
      if (signedIn) state.messages.push(message);
      else state.publicMessages.push(message);
      state.criteria = Object.assign({}, state.criteria || {}, constraints.criteria);
      state.cursor = "";
      sourcingConfirm.hidden = true;
      return { resultCount: results.length };
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function fallbackCatalogQuery(value) {
    var criteria = state.criteria || {};
    var structured = [criteria.product, criteria.category, criteria.query]
      .concat(Array.isArray(criteria.keywords) ? criteria.keywords : [criteria.keywords])
      .map(fallbackIdentityText)
      .find(Boolean);
    if (structured) return structured;
    var messages = signedIn ? state.messages : state.publicMessages;
    for (var index = messages.length - 2; index >= 0; index -= 1) {
      if (!messages[index] || messages[index].role !== "user") continue;
      var prior = fallbackIdentityText(messages[index].content);
      if (prior) return prior;
    }
    return fallbackIdentityText(value);
  }

  function fallbackIdentityText(value) {
    var input = customerMessage(plainText(value)).replace(/\s+/g, " ").trim().slice(0, 240);
    if (!input || isCatalogControlPhrase(input)) return "";
    return input
      .replace(/^\s*(?:please\s+)?(?:find|show|compare|recommend|help\s+me\s+(?:find|choose))\s+/i, "")
      .replace(/\b(?:under|below|less\s+than|up\s+to|max(?:imum)?)\s*\$?\s*\d+(?:\.\d{1,2})?\b/gi, " ")
      .replace(/\b(?:ship(?:ping)?|deliver(?:y)?)\s+(?:to|in)\s+[a-z][a-z .-]{1,36}$/i, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 180);
  }

  function isCatalogControlPhrase(value) {
    var text = String(value || "").toLowerCase().replace(/[^a-z0-9$]+/g, " ").trim();
    if (!text) return true;
    return /^(?:yes|confirm|confirmed|continue|retry|try again|go ahead|proceed|search now|show more|more results)\b/.test(text)
      || /^(?:search|show)\b.*\b(?:best|matching|matches|results?)\b/.test(text) && !/\b(?:toy|organizer|gift|bag|case|holder|rack|tool|product)\b/.test(text);
  }

  function fallbackConstraints(value) {
    var text = customerMessage(plainText(value)).toLowerCase();
    var budget = text.match(/\b(?:under|below|less\s+than|up\s+to|max(?:imum)?)\s*\$?\s*(\d+(?:\.\d{1,2})?)/i);
    var materials = ["solid wood", "wood", "metal", "acrylic", "silicone", "ceramic", "cotton", "leather", "plastic"];
    var storedMaterial = plainText(state.criteria && state.criteria.material || "").toLowerCase().trim();
    var material = materials.find(function (candidate) { return text.indexOf(candidate) >= 0; })
      || materials.find(function (candidate) { return storedMaterial.indexOf(candidate) >= 0; })
      || "";
    var storedExcluded = Array.isArray(state.criteria && state.criteria.exclude) ? state.criteria.exclude : [];
    var excluded = storedExcluded.map(function (term) { return plainText(term).toLowerCase().trim(); }).filter(Boolean);
    text.replace(/\b(?:without|exclude|excluding|no|not)\s+([a-z][a-z-]{1,30})/g, function (_match, term) {
      excluded.push(term);
      return _match;
    });
    var storedPriceMax = Number(state.criteria && state.criteria.price_max);
    var priceMax = budget ? Number(budget[1]) : (Number.isFinite(storedPriceMax) && storedPriceMax > 0 ? storedPriceMax : null);
    return {
      priceMax: Number.isFinite(priceMax) && priceMax > 0 ? priceMax : null,
      material: material,
      excluded: excluded,
      destinationRequested: /\b(?:ship|shipping|deliver|delivery|destination)\b/i.test(text) || Boolean(state.criteria && state.criteria.ship_to),
      criteria: {
        query: fallbackCatalogQuery(value),
        price_max: Number.isFinite(priceMax) && priceMax > 0 ? priceMax : undefined,
        material: material || undefined,
      },
    };
  }

  function fallbackProduct(product) {
    var handle = String(product && product.handle || "").trim();
    var title = plainText(product && product.title || "").replace(/\s+/g, " ").trim();
    if (!/^(?:wp-dcd|m4x)-\d+$/.test(handle) || !title || /[\u3400-\u9fff\uf900-\ufaff]/u.test(title) || product.available !== true) return null;
    var productUrl;
    try { productUrl = new URL(String(product.url || ""), window.location.origin); } catch (_error) { return null; }
    if (!safeStorefrontUrl(productUrl) || !productUrl.pathname.endsWith("/products/" + handle)) return null;
    var rawImage = typeof product.image === "string"
      ? product.image
      : product.image && product.image.url || product.featured_image && product.featured_image.url || "";
    var imageUrl;
    try { imageUrl = new URL(String(rawImage || ""), window.location.origin); } catch (_error) { return null; }
    if (!safeCatalogImage(imageUrl)) return null;
    var rawPrice = product.price && typeof product.price === "object" ? product.price.amount : product.price;
    var amount = Number(rawPrice);
    var currency = String(product.price && product.price.currency_code || "USD").toUpperCase();
    var searchable = [title, product.product_type, product.type, Array.isArray(product.tags) ? product.tags.join(" ") : product.tags]
      .filter(Boolean).map(plainText).join(" ").toLowerCase();
    return {
      title: title,
      handle: handle,
      product_url: productUrl.href,
      image_url: imageUrl.href,
      price_usd: Number.isFinite(amount) && amount > 0 ? amount : null,
      currency: /^[A-Z]{3}$/.test(currency) ? currency : "USD",
      available: true,
      availability: "available",
      fallback_search_text: searchable,
      why: "Available in the public Shopify catalog",
    };
  }

  function fallbackConstraintMatch(product, constraints) {
    var text = String(product.fallback_search_text || "").toLowerCase();
    if (constraints.priceMax != null && (!(Number(product.price_usd) > 0) || Number(product.price_usd) > constraints.priceMax)) return false;
    if (constraints.material && text.indexOf(constraints.material) < 0) return false;
    if (constraints.excluded.some(function (term) { return text.indexOf(term) >= 0; })) return false;
    return true;
  }

  function safeStorefrontUrl(url) {
    if (!(url instanceof URL) || url.origin !== window.location.origin) return false;
    return url.protocol === "https:" || (url.protocol === "http:" && /^(?:127\.0\.0\.1|localhost)$/.test(url.hostname));
  }

  function safeCatalogImage(url) {
    if (!(url instanceof URL) || url.protocol !== "https:") return false;
    return url.origin === window.location.origin || url.hostname === "cdn.shopify.com";
  }

  function renderConversation() {
    var messages = signedIn ? state.messages : state.publicMessages;
    transcript.replaceChildren();
    var meaningful = messages.filter(function (message) { return !isOperationalMessage(message); });
    welcome.hidden = meaningful.length > 0;
    if (!meaningful.length) transcript.appendChild(welcome);
    var recommendationIndexes = messages.reduce(function (indexes, message, index) {
      if (preparedResults((message.payload || {}).results).length) indexes.push(index);
      return indexes;
    }, []);
    var latestRecommendation = recommendationIndexes.length ? recommendationIndexes[recommendationIndexes.length - 1] : -1;
    var latestAssistant = latestMeaningfulAssistantIndex(messages);
    messages.forEach(function (message, index) {
      if (isOperationalMessage(message)) return;
      var results = preparedResults((message.payload || {}).results);
      if (results.length && index !== latestRecommendation) transcript.appendChild(renderPreviousRecommendation(message, results));
      else transcript.appendChild(renderTurn(message, index === latestAssistant, results));
    });
    renderProgress(messages);
    renderBrief();
    window.requestAnimationFrame(scrollToEnd);
  }

  function renderTurn(message, isLatest, suppliedResults) {
    var payload = message.payload || {};
    var turn = element("article", { className: "wp-agent-turn" + (message.role === "user" ? " is-user" : "") });
    if (message.role === "user") turn.appendChild(textNode("You", "wp-agent-turn-label"));
    var results = suppliedResults || preparedResults(payload.results);
    var copy = message.role === "user" ? customerMessage(message.content) : conciseConclusion(message.content, results);
    if (copy) turn.appendChild(textNode(copy, "wp-agent-turn-copy"));
    if (results.length) turn.appendChild(renderProducts(results, message));
    if (isLatest && message.role !== "user" && meaningfulDecision(payload, results)) {
      turn.appendChild(renderActions(payload.next_actions.slice(0, 3), payload));
    }
    if (isLatest && message.role !== "user" && (payload.action === "sourcing" || payload.dynamic_request_recommended === true)) {
      showSourcingConfirmation();
    }
    return turn;
  }

  function renderPreviousRecommendation(message, results) {
    var previous = element("details", { className: "wp-agent-previous" });
    previous.appendChild(textNode("Previous recommendation · " + String(results.length) + " products", "summary"));
    var body = element("div", { className: "wp-agent-previous-body" });
    var copy = conciseConclusion(message.content, results);
    if (copy) body.appendChild(textNode(copy, "wp-agent-turn-copy"));
    body.appendChild(renderProducts(results, message));
    previous.appendChild(body);
    return previous;
  }

  function renderProducts(results, message) {
    var custom = isCustomSourcingMessage(message);
    var ready = results.filter(function (result) { return !isUnavailable(result); });
    var unavailable = results.filter(isUnavailable);
    var module = element("section", { className: "wp-agent-recommendation " + (custom ? "is-custom" : "is-catalog") });
    var head = element("div", { className: "wp-agent-recommendation-head" });
    head.appendChild(textNode(custom ? "Custom sourcing results" : "Recommended from the catalog", "span"));
    head.appendChild(textNode(custom ? "Prepared for your brief" : "Best matches", "strong"));
    module.appendChild(head);
    if (ready.length) {
      module.appendChild(renderProduct(ready[0], "best", custom, ready.length));
      if (ready.length > 1) {
        var alternatives = element("div", { className: "wp-agent-alternatives", ariaLabel: "Alternative recommendations" });
        ready.slice(1, 3).forEach(function (result) { alternatives.appendChild(renderProduct(result, "alternative", custom, ready.length)); });
        module.appendChild(alternatives);
      }
    }
    if (ready.length > 3) {
      var more = element("details", { className: "wp-agent-products-more" });
      more.appendChild(textNode("View " + String(ready.length - 3) + " more matches", "summary"));
      var moreGrid = element("div", { className: "wp-agent-more-grid" });
      ready.slice(3).forEach(function (result) { moreGrid.appendChild(renderProduct(result, "alternative", custom, ready.length)); });
      more.appendChild(moreGrid);
      module.appendChild(more);
    }
    if (unavailable.length) module.appendChild(renderUnavailableProducts(unavailable, custom));
    return module;
  }

  function renderProduct(result, emphasis, custom, batchSize) {
    var product = element("article", { className: "wp-agent-product is-" + emphasis + (custom ? " is-custom" : "") });
    var imageUrl = stableAssetUrl(result.image || result.image_url || result.featured_image);
    var title = String(result.title || "Product");
    var displayTitle = conciseTitle(title);
    var media = element("div", { className: "wp-agent-product-media" });
    if (safeHttps(imageUrl)) media.appendChild(element("img", { src: imageUrl, alt: title }));
    product.appendChild(media);
    var body = element("div", { className: "wp-agent-product-body" });
    body.appendChild(textNode(emphasis === "best" ? "Best match" : emphasis === "reference" ? "Reference" : "Alternative", "span"));
    body.appendChild(element("h3", { text: displayTitle, title: title, ariaLabel: title }));
    var price = productPrice(result);
    if (price) body.appendChild(textNode(price, "wp-agent-product-price"));
    body.appendChild(textNode(deliveryLine(result, custom), "wp-agent-product-status"));
    if (emphasis === "best") {
      var facts = element("ul", { className: "wp-agent-fit-facts", ariaLabel: "Why it fits" });
      whyFacts(result).forEach(function (fact) { facts.appendChild(textNode(fact, "li")); });
      body.appendChild(facts);
    }
    var url = result.product_url || result.url;
    var actions = element("div", { className: "wp-agent-product-actions" });
    if (safeHttps(url)) actions.appendChild(link(emphasis === "reference" ? "View details" : "View & buy", url, title));
    if (emphasis === "best" && batchSize > 1) {
      var compare = element("button", { type: "button", text: "Compare" });
      compare.addEventListener("click", function () {
        sendMessage({ message: "Compare " + displayTitle + " with the other recommendations", operation: "chat", criteria: state.criteria });
      });
      actions.appendChild(compare);
    }
    body.appendChild(actions);
    product.appendChild(body);
    return product;
  }

  function renderUnavailableProducts(results, custom) {
    var references = element("details", { className: "wp-agent-unavailable-products" });
    references.appendChild(textNode("Unavailable references · " + String(results.length), "summary"));
    var grid = element("div", { className: "wp-agent-reference-grid" });
    results.forEach(function (result) { grid.appendChild(renderProduct(result, "reference", custom, 1)); });
    references.appendChild(grid);
    return references;
  }

  function renderActions(actions, payload) {
    var panel = element("div", { className: "wp-agent-next-actions" });
    actions.slice(0, 3).forEach(function (action, index) {
      var button = element("button", { className: index === 0 ? "is-primary" : "is-secondary", type: "button", text: action.label || action.message || "Continue" });
      button.addEventListener("click", function () {
        if (String(action.operation || "") === "dynamic_request") {
          showSourcingConfirmation();
          return;
        }
        sendMessage({
          message: action.message || action.label || "Continue",
          operation: action.operation || "chat",
          criteria: payload.criteria || state.criteria,
          cursor: payload.next_cursor || state.cursor,
        });
      });
      panel.appendChild(button);
    });
    return panel;
  }

  function renderBrief() {
    var criteria = state.criteria || {};
    var subject = criteria.use_case || criteria.category || criteria.product || criteria.query;
    var hasBrief = Boolean(subject || criteria.price_max != null || criteria.ship_to || criteria.material || criteria.recipient);
    var values = hasBrief ? [subject, criteria.price_max != null ? "Up to $" + criteria.price_max : "Open budget", criteria.ship_to ? "To " + criteria.ship_to : ""].filter(Boolean) : [];
    briefNode.hidden = values.length === 0;
    briefSummary.textContent = values.join(" · ");
  }

  function renderProgress(messages) {
    var operational = messages.filter(isOperationalMessage);
    progressNode.replaceChildren();
    progressNode.hidden = operational.length === 0 && !state.busy;
    if (progressNode.hidden) return;
    var progress = progressSnapshot(operational);
    var heading = element("div", { className: "wp-agent-progress-head" });
    heading.appendChild(textNode(progress.title, "strong"));
    heading.appendChild(textNode(progress.detail, "span"));
    progressNode.appendChild(heading);
    var steps = element("ol", { className: "wp-agent-progress-steps" });
    ["Brief saved", "Finding matches", "Preparing results"].forEach(function (label, index) {
      var item = textNode(label, "li");
      if (index < progress.step) item.className = "is-complete";
      else if (index === progress.step) item.className = "is-current";
      steps.appendChild(item);
    });
    progressNode.appendChild(steps);
  }

  function showSourcingConfirmation() {
    sourcingFacts.replaceChildren();
    var criteria = state.criteria || {};
    var facts = [
      ["Request", criteria.use_case || criteria.category || latestUserText() || "Current shopping brief"],
      ["Budget", criteria.price_max != null ? "Up to $" + criteria.price_max : "Open"],
      ["Destination", criteria.ship_to || "Confirm on task page"],
      ["Prepared results", "Up to 50 strongest verified matches, delivered together"],
    ];
    facts.forEach(function (fact) {
      var row = element("div");
      row.appendChild(textNode(fact[0], "dt"));
      row.appendChild(textNode(fact[1], "dd"));
      sourcingFacts.appendChild(row);
    });
    sourcingConfirm.hidden = false;
  }

  function startSourcing() {
    var brief = latestUserText() || briefSummary.textContent || "Help me source a product";
    try { window.sessionStorage.setItem("sfc:pending-agent-brief", brief); } catch (_error) {}
    var target = new URL(workspaceUrl, window.location.origin);
    target.searchParams.set("brief", brief.slice(0, 1000));
    target.searchParams.set("handoff_id", clientId("handoff").replace(/-/g, ""));
    if (signedIn) {
      window.location.assign(target.href);
      return;
    }
    var login = new URL(loginUrl, window.location.origin);
    login.searchParams.set("return_to", target.pathname + target.search);
    window.location.assign(login.href);
  }

  function contextualMessage(value) {
    if (state.productContextUsed || !root.dataset.productTitle) return value;
    return "Regarding the current product, \"" + root.dataset.productTitle + "\" (" + root.dataset.productUrl + "): " + value;
  }

  function customerMessage(value) {
    return String(value || "").replace(/^Regarding the current product,\s*"[^"]+"\s*\([^)]*\):\s*/i, "");
  }

  function renderProductContext() {
    if (!root.dataset.productTitle) return;
    contextNode.hidden = false;
    root.querySelector("[data-agent-context-title]").textContent = root.dataset.productTitle;
    root.querySelector("[data-agent-context-price]").textContent = root.dataset.productPrice || "";
  }

  function latestUserText() {
    var messages = signedIn ? state.messages : state.publicMessages;
    for (var index = messages.length - 1; index >= 0; index -= 1) {
      if (messages[index] && messages[index].role === "user") return customerMessage(messages[index].content);
    }
    return "";
  }

  function latestMeaningfulAssistantIndex(messages) {
    for (var index = messages.length - 1; index >= 0; index -= 1) {
      if (messages[index] && messages[index].role !== "user" && !isOperationalMessage(messages[index])) return index;
    }
    return -1;
  }

  function isOperationalMessage(message) {
    if (!message || message.role === "user") return false;
    var payload = message.payload || {};
    var kind = String(message.kind || payload.kind || payload.event_type || "").toUpperCase();
    var copy = String(message.content || "").toLowerCase();
    if (/RESULT/.test(kind) && preparedResults(payload.results).length) return false;
    return /^(SOURCING_|GOVERNANCE_|TASK_|AGENT_EXECUTION)/.test(kind)
      || ["queued", "searching", "preparing", "processing", "running"].includes(String(payload.status || payload.state || "").toLowerCase())
      || /request has been recorded|results are expected|is searching the catalog|product preparation|storylab governance|normal product workflow|agent execution|asynchronous source pool/.test(copy);
  }

  function isCustomSourcingMessage(message) {
    var payload = message && message.payload || {};
    var kind = String(message && message.kind || payload.kind || payload.event_type || "").toUpperCase();
    return /SOURCING|GOVERNANCE|PREPARED/.test(kind) || Boolean(payload.task_id || payload.sourcing_task_id || payload.custom_sourcing);
  }

  function progressSnapshot(operational) {
    var messages = signedIn ? state.messages : state.publicMessages;
    var readyCount = messages.reduce(function (count, message) {
      return Math.max(count, preparedResults((message.payload || {}).results).length);
    }, 0);
    if (readyCount) return { step: 3, title: "Results ready", detail: readyCount + " products are ready to review." };
    var text = operational.map(function (message) {
      var payload = message.payload || {};
      return [message.kind, payload.kind, payload.status, payload.state, message.content].filter(Boolean).join(" ");
    }).join(" ").toLowerCase();
    var count = operational.reduce(function (value, message) {
      var payload = message.payload || {};
      return Math.max(value, Number(payload.result_count || payload.match_count || payload.count || 0));
    }, 0);
    if (/prepar|govern|enhanc|image/.test(text)) return { step: 2, title: "Preparing your selection", detail: count ? count + " matches are being prepared." : "Matched products are being prepared." };
    if (/search|match|source|running/.test(text)) return { step: 1, title: "Finding the best matches", detail: "Your brief is being checked against available products." };
    return { step: 0, title: "Brief saved", detail: "Your shopping brief is ready." };
  }

  function meaningfulDecision(payload) {
    return Array.isArray(payload.next_actions) && payload.next_actions.some(function (action) {
      return action && String(action.label || action.message || "").trim();
    });
  }

  function conciseConclusion(value, results) {
    var text = sanitizeCustomerCopy(plainText(value));
    if (!text && results.length) return "Here are the strongest matches for your brief.";
    if (results.length && (!text || text.length > 240)) return "I found " + results.length + " strong matches for your brief.";
    var sentences = text.match(/[^.!?]+[.!?]?/g) || [];
    return String(sentences.slice(0, 2).join(" ").trim() || text).slice(0, 240);
  }

  function sanitizeCustomerCopy(value) {
    return String(value || "")
      .replace(/\bWP\b/gi, "our team")
      .replace(/StoryLab governance/gi, "product preparation")
      .replace(/enhanced product preparation/gi, "product preparation")
      .replace(/normal product workflow/gi, "order process")
      .replace(/agent execution/gi, "request")
      .replace(/asynchronous source pool/gi, "available products")
      .replace(/\s+/g, " ")
      .trim();
  }

  function conciseTitle(value) {
    var title = plainText(value).replace(/[\r\n]+/g, " ").replace(/\s+/g, " ").trim();
    var first = title.split(/\s*[|｜]\s*|\s+[-–—]\s+/)[0].trim();
    if (first.length >= 24) title = first;
    var words = title.split(" ").filter(Boolean);
    if (words.length > 10) title = words.slice(0, 10).join(" ");
    return title.slice(0, 88).replace(/[,;:\-–—\s]+$/, "") || "Product";
  }

  function whyFacts(result) {
    var unique = [];
    var raw = sanitizeCustomerCopy([result.title, result.why, result.summary, result.reason, result.product_type, result.type, result.material].filter(Boolean).map(plainText).join(" "));
    var type = plainText(result.product_type || result.type || "").trim();
    if (type && type.length <= 44) unique.push(type + (/(design|organizer|rack|holder|tray)$/i.test(type) ? "" : " design"));
    var material = ["solid wood", "wood", "metal", "acrylic", "silicone", "ceramic", "cotton", "leather"].find(function (value) { return raw.toLowerCase().includes(value); });
    if (material) unique.push(material.replace(/\b\w/g, function (letter) { return letter.toUpperCase(); }) + " construction");
    if (/compact|desktop|\bdesk\b/i.test(raw)) unique.push("Sized for desktop use");
    else if (/rotating|360/i.test(raw)) unique.push("Easy-access rotating design");
    else if (/multi[- ]?(tier|layer)|compartment/i.test(raw)) unique.push("Organized multi-compartment layout");
    unique = unique.filter(function (fact, index, list) { return list.findIndex(function (item) { return item.toLowerCase() === fact.toLowerCase(); }) === index; });
    if (!unique.length) unique.push("Matches the key details in your brief");
    if (unique.length < 2) unique.push("Ready to review on the product page");
    return unique.slice(0, 3);
  }

  function isUnavailable(result) {
    var status = String(result.availability || result.availability_status || result.status || "").toLowerCase();
    var catalogUnavailable = result.catalog_available === false || result.available === false;
    var purchaseUnverified = result.catalog_available === true
      && result.available !== false
      && result.purchasable === false;
    return catalogUnavailable
      || (!purchaseUnverified && result.purchasable === false)
      || /unavailable|sold out|reference only/.test(status);
  }

  function deliveryLine(result, custom) {
    if (isUnavailable(result)) return "Not currently available to buy";
    var line = plainText(result.delivery_status || result.delivery || result.shipping_summary || result.availability_text || "").trim();
    if (line && !/^available$/i.test(line) && !/order availability/i.test(line)) return line.slice(0, 92);
    return custom ? "Prepared for this brief · delivery at checkout" : "Delivery options confirmed at checkout";
  }

  function syncLayoutMode() {
    var docked = window.matchMedia("(min-width: 1280px)").matches;
    root.dataset.layout = docked ? "docked" : "overlay";
    drawer.setAttribute("aria-modal", docked ? "false" : "true");
  }

  function setBusy(value, message) {
    state.busy = Boolean(value);
    send.disabled = state.busy;
    input.disabled = state.busy;
    transcript.setAttribute("aria-busy", state.busy ? "true" : "false");
    renderProgress(signedIn ? state.messages : state.publicMessages);
  }

  function showStatus(message, tone) {
    var failure = tone === "success" ? null : customerFailure(message);
    statusNode.dataset.tone = tone || "error";
    statusTitle.textContent = tone === "success"
      ? sanitizeCustomerCopy(message || "Done")
      : failure.title;
    statusCopy.textContent = tone === "success"
      ? "Your conversation has been updated."
      : failure.copy;
    retryButton.hidden = tone === "success" || !state.retry;
    statusNode.hidden = false;
  }

  function showCatalogFallbackStatus(resultCount) {
    statusNode.dataset.tone = "degraded";
    statusTitle.textContent = "Limited catalog guidance is active.";
    statusCopy.textContent = resultCount
      ? "The conversational service is unavailable. The products below come from Shopify's public, read-only catalog search; no sourcing task was started."
      : "The conversational service is unavailable. No complete catalog result was asserted, and no sourcing task was started.";
    retryButton.hidden = true;
    statusNode.hidden = false;
  }

  function customerFailure(error) {
    var status = Number(error && error.status || 0);
    var messageSaved = Boolean(error && error.messageSaved);
    if (status === 401 || status === 403) {
      return {
        title: "Your Shopping Agent session needs to be refreshed.",
        copy: "Your conversation and current results are saved. Refresh the page or sign in again, then retry.",
      };
    }
    if (status === 429) {
      return {
        title: "Shopping Agent is busy right now.",
        copy: "Your conversation and current results are saved. Please wait a moment and try again.",
      };
    }
    if (messageSaved) {
      return {
        title: "Your message is saved.",
        copy: "Shopping Agent could not finish the reply yet. Try again to continue this saved conversation.",
      };
    }
    return {
      title: "Shopping Agent is temporarily unavailable.",
      copy: status
        ? "Your conversation and current results are saved. Please try again in a moment."
        : "Your conversation and current results are saved. Check your connection, then try again.",
    };
  }

  function clearStatus() {
    statusNode.hidden = true;
    delete statusNode.dataset.tone;
  }

  async function api(url, options) {
    var config = options || {};
    var response = await fetch(url, {
      method: config.method || "GET",
      credentials: signedIn && url.indexOf(accountApi) === 0 ? "same-origin" : "omit",
      headers: { "Accept": "application/json", "Content-Type": "application/json; charset=utf-8" },
      body: config.body,
    });
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      var error = new Error(response.status === 429
        ? "The catalog is receiving a lot of requests. Please wait a moment and try again."
        : payload.message || payload.error || "The Shopping Agent is temporarily unavailable.");
      error.status = response.status;
      error.code = String(payload.error || payload.code || "");
      error.payload = payload;
      error.messageSaved = payload.message_saved === true;
      error.conversationId = String(payload.conversation_id || "");
      throw error;
    }
    return payload;
  }

  function preparedResults(results) {
    if (!Array.isArray(results)) return [];
    return results.filter(function (result) {
      return result && String(result.title || "").trim() && safeHttps(result.product_url || result.url);
    });
  }

  function productPrice(result) {
    var raw = result.price_usd != null ? result.price_usd : result.price;
    var amount = Number(raw);
    if (!Number.isFinite(amount) || amount <= 0) return "";
    return (result.price_varies ? "From " : "") + "$" + amount.toFixed(2) + " " + (result.currency || "USD");
  }

  function resizeInput() {
    input.style.height = "auto";
    input.style.height = Math.min(126, Math.max(46, input.scrollHeight)) + "px";
  }

  function trapFocus(event) {
    var focusable = Array.from(drawer.querySelectorAll("a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex='-1'])"))
      .filter(function (node) { return !node.hidden && node.getClientRects().length > 0; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function scrollToEnd() { transcript.scrollTop = transcript.scrollHeight; }
  function safeHttps(value) {
    try {
      var url = new URL(String(value || ""));
      return url.protocol === "https:" || (url.protocol === "http:" && /^(?:127\.0\.0\.1|localhost)$/.test(url.hostname));
    } catch (_error) { return false; }
  }
  function stableAssetUrl(value) {
    try {
      var url = new URL(String(value || ""));
      if (url.protocol !== "https:") return "";
      if (url.hostname === "wp-governance.htfu.workers.dev" && url.pathname.indexOf("/rich-media-assets/") === 0) {
        url.hostname = "wp-api.sendfromchina.ai";
      }
      return url.toString();
    } catch (_error) { return ""; }
  }
  function plainText(value) { return new DOMParser().parseFromString(String(value || ""), "text/html").body.textContent || ""; }
  function formatDate(value) { var date = new Date(value || ""); return Number.isNaN(date.getTime()) ? "Saved conversation" : date.toLocaleString(); }
  function clientId(prefix) { return prefix + "_" + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID().replace(/-/g, "") : Date.now().toString(36) + Math.random().toString(36).slice(2)); }
  function link(label, href, accessibleLabel) { return element("a", { text: label, href: href, ariaLabel: accessibleLabel ? label + ": " + accessibleLabel : label }); }
  function textNode(value, className) { return element(["strong", "span", "h3", "p", "summary", "dt", "dd", "li"].includes(className) ? className : "p", { className: !["strong", "span", "h3", "p", "summary", "dt", "dd", "li"].includes(className) ? className : "", text: value }); }
  function element(tag, options) {
    var output = document.createElement(tag);
    var values = options || {};
    if (values.className) output.className = values.className;
    if (values.text !== undefined) output.textContent = String(values.text);
    if (values.type) output.type = values.type;
    if (values.href) output.href = values.href;
    if (values.src) output.src = values.src;
    if (values.alt !== undefined) output.alt = values.alt;
    if (values.title) output.title = values.title;
    if (values.ariaLabel) output.setAttribute("aria-label", values.ariaLabel);
    return output;
  }
})();
